import { atom } from 'recoil';
import {getCookie} from "../../cookie/Cookie";

// 쿠키에서 초기값 가져오기
const initialAuthState = getCookie('auth') ? getCookie('auth') : {
    loginStatus: 'NOT_LOGGED_IN',
    teacher: {},
    token: {}
};

// Recoil Atom
export const authState = atom({
    key: 'authState',
    default: initialAuthState
});
